










































































import { Component, Vue } from 'vue-property-decorator';
import NOC from '@/class/common/const' ;
import util from '@/components/util';
// import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/BasicGadget.vue';
import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/EditerBasicGadget.vue';
// import MaterialsList from '@/parts/graph/MaterialsList.vue';
import MaterialsListV2 from '@/parts/graph/MaterialsListV2.vue';

import * as models from '@/class/models/views/graph';
import API from '@/api/common';
import gadgets from '@/components/gadgets';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';
import * as validation from '@/personal/validation';


export default Vue.extend({
  name: 'GadgetEditer',
  components: {
    ...util,
    BasicGadget,
    MaterialsListV2,
    VariableInput,
  },
  props: {
    indexs: Array,
    selectGadget: Object,
    confirmDialog: Function,
  },
  computed: {
    MATERIAL_TARGET() {
      return NOC.MATERIAL.V3.MATERIALS.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET));
    },
    MATERIAL_MEASURE() {
      return NOC.MATERIAL.V3.MATERIALS.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.MEASURE));
    },
    MATERIAL_DIMENSION() {
      return NOC.MATERIAL.V3.MATERIALS.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
    },
    GRAPHS() {
      return VUECHARTGRAPH;
    },
    EDIT() {
      return true;
    },
  },
  data() {
    return {
      gadgets : [] as models.IGadget[],
      sideModal: false,
      editGadget: new models.CGadget(),
      editValues: new models.CValues(),
      selectGraphClass: '',
      frameData: new CFrame(),
      items: [
        {key: 'title', name: 'グラフタイトル', type: INPUT_TYPE.TEXT, placeholder: 'タイトルを入力してください', required: false, checks: [], error: '', max: 20},
        {key: 'comment', name: 'メモ', type: INPUT_TYPE.TEXTAREA, placeholder: '200文字以内', required: false, checks: [], error: '', max: 200},
      ] as IVariableInput[],
      detailModal: false,
      editOptions: {},
    };
  },
  created() {
    // frame設定
    this.frameData.edit = true;
    this.frameData.options = true;
    // Dashboardから編集
    if (this.selectGadget.gadgetID) {
      const editGadget = this.selectGadget as unknown as any;
      this.setGadget(editGadget);
      // this.onEdit(editGaget);
    }
  },
  async mounted() {
    // console.log('moutend')
    this.$emit('pushPath', this.$route.path);
    this.editGadget.gadget = 'BasicGadget';

    /*
    // データ取得
    const api = new API();
    const res = await api.get<models.VGraph>('graph');
    // console.log(res);
    if (res.result) {
      this.gadgets = res.data.gadgets;
    }
    */
  },
  methods: {
    frameDataEdit(frameData: any) {
      this.editGadget.title = frameData.title;
      this.editGadget.comment = frameData.comment;
    },
    setOptions(data: any) {
      this.editOptions = data;
      // console.log('this.editOptions', this.editOptions);
    },
    setValues(data: models.IValues) {
      this.editValues.setData = data.setData;
      this.editValues.date = data.date;
      this.frameData.detail = false;
      if (data.setData.length > 0 && data.date.length >= 10 && data.setData !== '0') {
        this.frameData.detail = true;
      }
    },
    setGadget(gadget: any) {
      this.selectGraphClass = gadget.data.graph[0].key;
      this.sideModal = false;
      this.editGadget = gadget;
    },
    onClickGadgetList() {
      this.sideModal = !this.sideModal;
    },
    // グラフ要素選択時イベント
    onClickSelectGraphIcon(graph: IGraph) {
      const result = this.editGadget.data.graph.find((v) => (v.key === graph.key));
      if (!result) {
        const newGraph = new models.CDomain();
        newGraph.key = graph.key;
        this.selectGraphClass = graph.key;
        this.editGadget.data.graph = [newGraph];
      } else {
        this.selectGraphClass = '';
        this.editGadget.data.graph = [];
      }
      // this.gadgetData.data.graph = this.selectGraph;
    },
    // 要素選択処理
    onClickMaterials(selectValue: models.IDomain) {
      if (this.editGadget.data.materials.indexOf(selectValue) === -1) {
        if (this.editGadget.data.materials.length > 0) {
          this.editGadget.data.materials = this.editGadget.data.materials
            .filter((v) =>
            (selectValue.reject.indexOf(v.id) === -1 && v.id !== selectValue.id));
        }
        this.editGadget.data.materials.push(selectValue);
      } else {
        this.editGadget.data.materials = this.editGadget.data.materials
          .filter((v: models.IDomain) => (selectValue.id !==  v.id));
      }
      // console.log(this.gadgetData.data.materials);
      // console.log(this.gadgetData);
      // this.gadgetData.data.materials = this.gadgetData.data.materials;
    },
    // todo:型
    classGraphIcon(value: any) {
      return {
        selected: value === this.selectGraphClass,
      };
    },
    // グラフ登録
    async onClickRegistGraph() {
      const formData = {
        title: this.editGadget.title,
        comment: this.editGadget.comment,
      };

      if (this.editGadget.title.length <= 0 || (validation.checkValues(formData, this.items) > 0)) {
        const titleMax = this.$data.items.filter((x: IVariableInput) => x.key === 'title')[0].max;
        const commentMax = this.$data.items.filter((x: IVariableInput) => x.key === 'comment')[0].max;
        if (this.$data.editGadget.comment.length > commentMax) {
          this.$emit('info', `コメントは${commentMax}文字以内で入力してください。`);
        }
        if (this.$data.editGadget.title.length > titleMax) {
          this.$emit('info', `タイトルは${titleMax}文字以内で入力してください。`);
        } else {
          this.$emit('info', '入力不備があります。');
        }
        return;
      }
      // this.setGadgetData();
      this.editGadget.options = this.editOptions;
      const requestData: models.VGraphEdit = {
        gadget: this.editGadget,
        values: this.editValues,
      };
      // api start
      const api = new API();
      let res;
      if (this.editGadget.gadgetID === 0) {
        res = await api.post<models.VGraphEdit, any>('graph/new', requestData);
      } else {
        res = await api.put<models.VGraphEdit, any>('graph/edit', requestData);
      }
      // console.log(res);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.gadgets = res.data.gadgets;
        this.$emit('updateGadgets', res.data.gadgets);
        this.$emit('info', 'グラフを登録しました。');
      } else {
        this.$emit('info', '登録できませんでした。');
      }
    },
    // onClickDelteGraph() {},
    async onClickDelteGraph() {
      if (await this.confirmDialog('選択中のグラフを削除します、よろしいでしょうか？')) {
        const targetID = this.editGadget.gadgetID;
        // ダッシュボードで使用中の場合削除不可
        let deleteFlag = true;
        for (const layoutIndex of this.indexs) {
          const useLayout = (layoutIndex as any).layout.find((v: any) => (v.gadgetID === targetID && v.default === false));
          if (useLayout) {
            deleteFlag = false;
            break;
          }
        }
        if (!deleteFlag) {
          this.$emit('info', '使用中のため削除できません。');
          return;
        }
        const api = new API();
        const res = await api.delete<models.VGraph>('graph/delete', {deleteID: targetID});
        if (res.result) {
          // this.gadgets = res.data.gadgets;
          this.$emit('updateGadgets', res.data.gadgets);
        } else {
          this.$emit('info', '削除できませんでした。');
        }
      }
    },
    showDetail(values: models.IValues) {
      // console.log('showDetail', values);
      this.editValues = values;
      this.detailModal = true;
    },
  },
});
